"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgMedicineBottleFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { clipRule: 'evenodd', d: 'M3 7.994h18v11.99c0 1.306-.667 1.972-2 1.997-1.333.025-6 .025-14 0-1.333 0-2-.666-2-1.998V7.994zM4.038 2H20c1.333 0 2 .666 2 1.998V6H2V3.998C2 2.666 2.68 2 4.038 2zM11 12v1.996L8.996 14C8.332 14 8 14.333 8 15s.332 1 .996 1H11v2c0 .667.333 1 1 1s1-.333 1-1v-2h2.002c.665 0 .998-.333.998-1s-.333-1.001-.998-1.004L13 14v-2c0-.667-.333-1-1-1s-1 .333-1 1z' }))); };
exports.default = SvgMedicineBottleFilled;
//# sourceMappingURL=MedicineBottleFilled.js.map